module.exports = __webpack_public_path__ + "static/media/dispensary-expanded.f118300c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/dispensary-expanded.svg
// module id = 1954
// module chunks = 0